import { Component } from "preact";
import '../style/message-item.css';

export default class MessageItem extends Component {
    render() {
        return (
            <div className={'message-item-wrapper ' + (this.props.isSelf ? 'to' : 'from')}>
                <div className={'message-item'}>
                    {this.props.text}
                </div>
            </div>
        )
    }
}